var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"cl-logo",attrs:{"src":_vm.centro_logo},on:{"error":function($event){_vm.failed = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }